import { createContext, useContext, useMemo, useReducer } from 'react'
import { TWithChildren, TMainApi, TMainState } from './main.type'
import { TypeActions } from './main.actions'
import { reducer } from './main.reducer'

const MainContext = createContext({} as TMainApi)

const SelectedItemsContext = createContext([] as string[] | undefined)

export const MainDataProvider = ({ children }: TWithChildren) => {
  const [state, dispatch] = useReducer(reducer, {} as TMainState)
  const api = useMemo(
    () => ({
      onSelectItem(ids: string[]) {
        dispatch({ type: TypeActions.SELECTED_IDS, payload: ids })
      },
      clearSelectedItems() {
        dispatch({ type: TypeActions.SELECTED_IDS, payload: [] })
      },
    }),
    []
  )
  return (
    <MainContext.Provider value={api}>
      <SelectedItemsContext.Provider value={state.selectedIds || []}>
        {children}
      </SelectedItemsContext.Provider>
    </MainContext.Provider>
  )
}

export const useMonitoring = () => {
  const api = useContext(MainContext)
  if (!api) {
    throw new Error('MainContext was not found')
  }

  return api
}

export const useSelectedItems = () => {
  const ids = useContext(SelectedItemsContext)
  if (!ids) {
    throw new Error('SelectedItemsContext was not found')
  }
  return ids
}
